module.exports = __webpack_public_path__ + "static/media/1-2-diploma-postframed.a3d4b223.webp";